import React from "react";
import styles from "./OurServices.module.scss";
import CDMOSVG from "./CDMOSVG";
import CMOSVG from "./CMOSVG";
import CROSVG from "./CROSVG";

const services = [
  {
    id: 1,
    serviceName: "CDMO – Development to Production",
    serviceDescription:
      "We help you develop new products and scale them up for manufacturing.",
    icon: CDMOSVG,
  },
  {
    id: 2,
    serviceName: "CMO – Scalable Manufacturing",
    serviceDescription:
      "We manufacture your existing products at the right scale and quality.",
    icon: CMOSVG,
  },
  {
    id: 3,
    serviceName: "CRO – Research Support",
    serviceDescription:
      "We assist with early-stage research, testing, and formulation development.",
    icon: CROSVG,
  },
];

const ServiceCard = ({ service }) => {
  return (
    <div className={styles.serviceCard}>
      {/* Icon */}
      {service.icon()}
      {/* serviceName */}
      <div className={styles.serviceName}>{service.serviceName}</div>
      {/* serviceDescription */}
      <div className={styles.serviceDescription}>
        {service.serviceDescription}
      </div>
    </div>
  );
};

function OurServices() {
  return (
    <div className={styles.ourServices}>
      {/* Heading */}
      <h2>Our Services</h2>
      {/* Description */}
      <p>
        Elchemy provides full-spectrum services across early-stage R&D,
        scale-up, and commercial manufacturing through our CDMO, CMO, and CRO
        models.
      </p>
      {/* Row of Service Cards */}
      <div className={styles.serviceCardsRow}>
        {services.map((service) => (
          <ServiceCard key={service.id} service={service} />
        ))}
      </div>
    </div>
  );
}

export default OurServices;
